// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root___qvCO","header":"PatientBlock_header__1yvAi","label":"PatientBlock_label__t71Qh","option":"PatientBlock_option__UC8ny"};